module.exports = __webpack_public_path__ + "img/housekeeping-info.55853fcb.svg";